(function () {
  var root = document.getElementById('anCart');
  if (!root) return;
  var THRESHOLD = parseInt(root.getAttribute('data-free-ship'), 10) || 15000;
  var itemsEl = root.querySelector('[data-cart-items]');
  var emptyEl = root.querySelector('[data-cart-empty]');
  var footEl = root.querySelector('[data-cart-foot]');
  var countEl = root.querySelector('[data-cart-count]');
  var subEl = root.querySelector('[data-cart-subtotal]');
  var shipEl = root.querySelector('[data-cart-ship]');
  var shipMsg = root.querySelector('[data-cart-ship-msg]');
  var shipFill = root.querySelector('[data-cart-ship-fill]');
  var giveText = root.querySelector('[data-cart-give-text]');

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  // ---- give-back: per line, from Adam's own fields -------------------------
  // /cart.js has no tags or product fields, so /cart?view=give
  // (templates/cart.give.liquid) returns each line's tags, charity_beneficiary,
  // charity_share_pct and whether it is in the adams-nest-gives-back collection.
  // ANCartGive.resolveLine decides what gives back and at what rate (see
  // an-cart-give.js). If the view can't load, nothing is counted (never
  // over-counts). Replaced the collection-only lookup on 2026-10-16: Adam tags
  // and fills the fields, and the cart showed $0 for anything he did not also
  // add to that collection by hand.
  var CHARITIES = (typeof window !== 'undefined' && window.AN_CHARITIES) || [];

  function loadCauseMap() {
    // No Accept: application/json header here: with it Shopify answers with the
    // plain /cart.js data and skips this view (no tags, no charity fields).
    return fetch('/cart?view=give')
      .then(function (r) { return r.ok ? r.text() : '{"items":[]}'; })
      .then(function (t) { return JSON.parse(t); })
      .then(function (d) {
        var map = {}; // { product_id: {s: share, f: flatCents} }
        (d.items || []).forEach(function (it) {
          var g = window.ANCartGive.resolveLine({
            tags: it.tags,
            beneficiary: it.beneficiary,
            sharePct: it.share_pct,
            inGivesBack: it.in_gives_back
          }, CHARITIES);
          map[it.product_id] = { s: g.share, f: g.flatCents };
        });
        return map;
      })
      .catch(function () { return {}; });
  }

  function updateGive(cents) {
    if (!giveText) return;
    if (cents > 0) giveText.innerHTML = '<b>' + money(cents) + '</b> of this order goes to LGBTQ+ orgs.';
    else giveText.innerHTML = 'Every cause piece sends 10% straight back to LGBTQ+ orgs.';
  }

  // Instant give-back from on-screen lines using shares already stamped on nodes.
  function optimisticGive() {
    if (!giveText || !window.ANCartGive) return;
    var lines = [];
    itemsEl.querySelectorAll('.an-ci:not(.removing)').forEach(function (n) {
      var q = parseInt(n.querySelector('.an-ci-q').textContent, 10) || 0;
      var unit = parseInt(n.getAttribute('data-unit'), 10) || 0;
      lines.push({
        lineCents: unit * q,
        share: parseFloat(n.getAttribute('data-give-share')) || 0,
        flatCents: parseInt(n.getAttribute('data-give-flat'), 10) || 0,
        qty: q
      });
    });
    updateGive(window.ANCartGive.giveCents(lines));
  }

  // Authoritative: stamp each line's share + flat from the cause map, then render.
  function refreshGive() {
    if (!giveText || !window.ANCartGive) return;
    loadCauseMap().then(function (map) {
      itemsEl.querySelectorAll('.an-ci:not(.removing)').forEach(function (n) {
        var g = (map && map[n.getAttribute('data-pid')]) || null;
        n.setAttribute('data-give-share', (g && g.s) || 0);
        n.setAttribute('data-give-flat', (g && g.f) || 0);
      });
      optimisticGive();
    });
  }

  function setOpen(open) {
    if (open && !everOpened) { everOpened = true; if (lastCart) { refreshGive(); renderBundle(lastCart); } }
    root.classList.toggle('open', open);
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) { var c = root.querySelector('.an-cart-x'); c && c.focus({ preventScroll: true }); }
  }

  function badge(count) {
    document.querySelectorAll('.cart-count').forEach(function (b) {
      b.textContent = count;
      if (count > 0) b.removeAttribute('hidden'); else b.setAttribute('hidden', '');
    });
  }

  function renderShip(total) {
    var remaining = Math.max(0, THRESHOLD - total);
    var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
    shipEl.removeAttribute('hidden');
    shipFill.style.width = pct + '%';
    if (remaining === 0) { shipMsg.innerHTML = '<b>Free shipping unlocked.</b>'; shipEl.classList.add('done'); }
    else { shipMsg.innerHTML = "You're <b>" + money(remaining) + "</b> from free shipping"; shipEl.classList.remove('done'); }
  }

  function renderTotals(totalCents, itemCount) {
    badge(itemCount);
    countEl.textContent = itemCount + (itemCount === 1 ? ' item' : ' items');
    subEl.textContent = money(totalCents);
    renderShip(totalCents);
    // Give-back is NOT a cut of the whole total; it is summed from cause lines
    // only by refreshGive()/optimisticGive().
  }

  // ---- automatic discounts, named ----------------------------------------
  // Shopify applies Adam's multi-buy discounts ("three t-shirts" 15%, hats,
  // pins, stickers...) silently: line prices just drop with no explanation.
  // Name each one so the shopper knows what they earned (Red Fox walkthrough,
  // 2026-09-17). Line prices are already net of these, so this row is a
  // "you saved" note, not a second subtraction.
  var discEl = root.querySelector('[data-cart-discounts]');
  function prettyDiscount(t) { t = String(t || 'Discount').trim(); return t.charAt(0).toUpperCase() + t.slice(1); }
  function renderDiscounts(cart) {
    if (!discEl) return;
    var by = {}, order = [];
    function addAmt(t, cents) { if (!by[t]) { by[t] = 0; order.push(t); } by[t] += cents || 0; }
    (cart.cart_level_discount_applications || []).forEach(function (d) { addAmt(d.title, d.total_allocated_amount); });
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (a) {
        addAmt(a.discount_application && a.discount_application.title, a.amount);
      });
    });
    if (!order.length) { discEl.setAttribute('hidden', ''); discEl.innerHTML = ''; return; }
    discEl.innerHTML = order.map(function (t) {
      return '<div class="an-cart-disc"><b>' + esc(prettyDiscount(t)) + '</b> &middot; you saved ' + money(by[t]) + '</div>';
    }).join('');
    discEl.removeAttribute('hidden');
  }

  // ---- tee multi-buy nudge -------------------------------------------------
  // The automatic "three t-shirts" (15%) / "five t-shirts" (25%) discounts cover
  // the made-to-order tees Adam tags SPECIAL (collection on-demand-special).
  // /cart.js exposes no tags, so load that collection's product ids once per
  // session, exactly like the cause map, and count qualifying units in the bag.
  var bundleEl = root.querySelector('[data-cart-bundle]');
  var BUNDLE_HANDLE = 'on-demand-special';
  var bundleSet = null;
  function fetchBundlePage(page, acc) {
    return fetch('/collections/' + BUNDLE_HANDLE + '/products.json?limit=250&page=' + page, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var ps = d.products || [];
        ps.forEach(function (p) { acc[p.id] = 1; });
        return ps.length === 250 ? fetchBundlePage(page + 1, acc) : acc;
      });
  }
  function loadBundleSet() {
    if (bundleSet) return Promise.resolve(bundleSet);
    try { var raw = sessionStorage.getItem('an-bundle-set-v1'); if (raw) { bundleSet = JSON.parse(raw); return Promise.resolve(bundleSet); } } catch (e) {}
    return fetchBundlePage(1, {})
      .then(function (s) { bundleSet = s; try { sessionStorage.setItem('an-bundle-set-v1', JSON.stringify(s)); } catch (e) {} return s; })
      .catch(function () { return {}; });
  }
  function renderBundle(cart) {
    if (!bundleEl) return;
    loadBundleSet().then(function (set) {
      var n = 0;
      (cart.items || []).forEach(function (it) { if (set[it.product_id]) n += it.quantity; });
      var msg = '';
      if (n >= 5) msg = '<b>25% off your tees</b> is on: five or more made-to-order tees save 25%.';
      else if (n >= 3) msg = '<b>15% off your tees</b> is on. Add ' + (5 - n) + ' more made-to-order tee' + (5 - n === 1 ? '' : 's') + ' and the saving grows to 25%.';
      else if (n >= 1) msg = 'Add ' + (3 - n) + ' more made-to-order tee' + (3 - n === 1 ? '' : 's') + ' and <b>save 15% on all of them</b>. <a href="/collections/' + BUNDLE_HANDLE + '">Pick tees &rarr;</a>';
      if (msg) { bundleEl.innerHTML = msg; bundleEl.removeAttribute('hidden'); }
      else { bundleEl.setAttribute('hidden', ''); bundleEl.innerHTML = ''; }
    });
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function lineHTML(it) {
    var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<span class="an-ci-variant">' + it.variant_title + '</span>' : '';
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    var unit = it.quantity > 0 ? Math.round(it.final_line_price / it.quantity) : 0;
    // Pre-order lines carry a "Pre-order" property written by the product page
    // (sections/main-an-product.liquid) — the shopper should keep seeing it in the bag.
    var po = it.properties && it.properties['Pre-order'];
    var preorder = po ? '<span class="an-ci-preorder">' + esc(po) + '</span>' : '';
    return '' +
      '<div class="an-ci" data-key="' + it.key + '" data-unit="' + unit + '" data-pid="' + it.product_id + '">' +
        '<a class="an-ci-media" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="an-ci-info">' +
          '<a class="an-ci-title" href="' + it.url + '">' + it.product_title + '</a>' +
          variant +
          preorder +
          '<div class="an-ci-row">' +
            '<div class="an-ci-qty">' +
              '<button type="button" class="an-ci-step" data-step="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="an-ci-q">' + it.quantity + '</span>' +
              '<button type="button" class="an-ci-step" data-step="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<span class="an-ci-price">' + money(it.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="an-ci-remove" data-remove aria-label="Remove">Remove</button>' +
        '</div>' +
      '</div>';
  }

  function makeLine(it) {
    var tmp = document.createElement('div');
    tmp.innerHTML = lineHTML(it);
    return tmp.firstChild;
  }

  // Slide a new line in (two rAFs so the initial state paints before transitioning).
  function enterLine(node) {
    node.classList.add('entering');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { node.classList.remove('entering'); });
    });
  }

  // Collapse a removed line: pin its height, then transition to 0 with the
  // .removing class. JS sets heights because line heights vary.
  function collapseLine(node) {
    if (node.classList.contains('removing')) return;
    node.style.height = node.offsetHeight + 'px';
    node.style.overflow = 'hidden';
    void node.offsetHeight; // commit the pinned height before transitioning
    node.classList.add('removing');
    node.style.height = '0px';
    setTimeout(function () { node.remove(); syncEmptyState(); }, 320);
  }

  function syncEmptyState() {
    var hasLines = !!itemsEl.querySelector('.an-ci:not(.removing)');
    if (hasLines) {
      emptyEl.setAttribute('hidden', '');
      footEl.removeAttribute('hidden');
    } else {
      emptyEl.removeAttribute('hidden');
      footEl.setAttribute('hidden', '');
      shipEl.setAttribute('hidden', '');
      if (crossEl) crossEl.setAttribute('hidden', '');
    }
  }

  // ---- optimistic change queue ----------------------------------------
  // Clicks update the UI instantly; the latest desired qty per line is
  // debounced and sent one request at a time. Server responses reconcile
  // everything except lines that still have unsent edits.
  var pendingQty = {};      // key -> latest desired qty (not yet sent)
  var debounceTimers = {};  // key -> timer id
  var changeInflight = false;

  function hasPending(key) { return Object.prototype.hasOwnProperty.call(pendingQty, key) || !!debounceTimers[key]; }

  function queueChange(key, qty) {
    pendingQty[key] = qty;
    clearTimeout(debounceTimers[key]);
    debounceTimers[key] = setTimeout(function () {
      delete debounceTimers[key];
      flushChanges();
    }, 280);
  }

  function flushChanges() {
    if (changeInflight) return;
    var keys = Object.keys(pendingQty).filter(function (k) { return !debounceTimers[k]; });
    if (!keys.length) return;
    var key = keys[0];
    var qty = pendingQty[key];
    delete pendingQty[key];
    changeInflight = true;
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { if (!r.ok) throw new Error('cart change failed'); return r.json(); })
      .then(function (cart) { applyCart(cart); })
      .catch(function () { fetchCart(false); }) // re-sync UI from the server on any failure
      .finally(function () { changeInflight = false; flushChanges(); });
  }

  // Recompute totals locally from what's on screen so the subtotal, free-ship
  // bar and giving line move the instant a quantity changes. The next server
  // response replaces these with authoritative numbers.
  function optimisticTotals() {
    var total = 0, count = 0;
    itemsEl.querySelectorAll('.an-ci:not(.removing)').forEach(function (n) {
      var q = parseInt(n.querySelector('.an-ci-q').textContent, 10) || 0;
      total += (parseInt(n.getAttribute('data-unit'), 10) || 0) * q;
      count += q;
    });
    renderTotals(total, count);
    optimisticGive();
    if (count === 0) syncEmptyState();
  }

  // ---- cross-sell rail --------------------------------------------------
  var crossEl = root.querySelector('[data-cart-cross]');
  var crossRail = root.querySelector('[data-cart-cross-rail]');
  var crossPid = null;

  // Remove cross-sell cards whose product is now in the bag, with a clean
  // slide-out. We do NOT re-fetch / replace the whole rail on every add.
  function pruneCross(cart) {
    if (!crossEl) return;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    crossRail.querySelectorAll('.an-cross-card').forEach(function (card) {
      var pid = parseInt(card.getAttribute('data-pid'), 10);
      if (inCart[pid] && !card.classList.contains('removing')) {
        card.classList.add('removing');
        setTimeout(function () {
          card.remove();
          if (!crossRail.querySelector('.an-cross-card')) crossEl.setAttribute('hidden', '');
        }, 280);
      }
    });
  }

  // "Pairs well with": one apparel + one accessory + one pin/postcard.
  var CROSS_ORDER = ['apparel', 'accessory', 'pins'];
  var CROSS_FALLBACK = { apparel: 'apparel', accessory: 'accessories', pins: 'adams-nest-pins-patches' };

  function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; } return a; }

  function crossCardHTML(n) {
    var img = n.img ? n.img.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
    return '<div class="an-cross-card" data-pid="' + n.id + '">' +
      '<a class="an-cross-media" href="' + n.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
      '<div class="an-cross-info"><a class="an-cross-title" href="' + n.url + '">' + n.title + '</a>' +
      '<span class="an-cross-price">' + money(n.priceCents) + '</span></div>' +
      (n.variantId ? '<button type="button" class="an-cross-add" data-quick-add data-variant-id="' + n.variantId + '" aria-label="Add ' + (n.title || '').replace(/"/g, '') + '">+</button>' : '') +
      '</div>';
  }

  // Prefer products related to the cart for each bucket; fill any empty bucket
  // from that category's collection so the rail is always a true mix.
  function buildDiverse(pid, inCart) {
    var X = window.ANCartCross;
    return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (d) {
        var recs = shuffle((d.products || []).slice());
        var picked = {}, result = {};
        CROSS_ORDER.forEach(function (b) { var p = X.firstOf(recs, b, inCart, picked); if (p) { result[b] = p; picked[p.id] = true; } });
        var missing = CROSS_ORDER.filter(function (b) { return !result[b]; });
        if (!missing.length) return result;
        return Promise.all(missing.map(function (b) {
          return fetch('/collections/' + CROSS_FALLBACK[b] + '/products.json?limit=16', { headers: { 'Accept': 'application/json' } })
            .then(function (r) { return r.ok ? r.json() : { products: [] }; })
            .then(function (cd) { var p = X.firstOf(shuffle((cd.products || []).slice()), b, inCart, picked); if (p) { result[b] = p; picked[p.id] = true; } })
            .catch(function () {});
        })).then(function () { return result; });
      });
  }

  function renderCross(cart) {
    if (!crossEl || !cart.items.length || !window.ANCartCross) { if (crossEl) crossEl.setAttribute('hidden', ''); return; }
    // Keep the SAME anchor product as long as it's still in the bag, so
    // cross-adds only prune instead of re-fetching the whole rail.
    var anchored = crossPid && cart.items.some(function (i) { return i.product_id === crossPid; });
    if (anchored && crossRail.querySelector('.an-cross-card')) { pruneCross(cart); return; }
    crossPid = cart.items[0].product_id;
    var inCart = {};
    cart.items.forEach(function (i) { inCart[i.product_id] = true; });
    buildDiverse(crossPid, inCart).then(function (result) {
      var picks = CROSS_ORDER.map(function (b) { return result[b]; }).filter(Boolean).map(window.ANCartCross.normalize);
      if (!picks.length) { crossEl.setAttribute('hidden', ''); return; }
      crossRail.innerHTML = picks.map(crossCardHTML).join('');
      crossEl.removeAttribute('hidden');
    }).catch(function () { crossEl.setAttribute('hidden', ''); });
  }

  // ---- reconcile server cart into the DOM (no innerHTML nuke) -----------
  // Lines are updated in place; new lines slide in; gone lines collapse out.
  // Lines with unsent local edits are left alone so optimistic state wins
  // until its own request settles.
  var lastCart = null, everOpened = false;
  function applyCart(cart) {
    lastCart = cart;
    renderTotals(cart.total_price, cart.item_count);
    renderDiscounts(cart);

    var byKey = {};
    itemsEl.querySelectorAll('.an-ci').forEach(function (n) { byKey[n.getAttribute('data-key')] = n; });

    var seen = {};
    var prev = null;
    cart.items.forEach(function (it) {
      seen[it.key] = true;
      var node = byKey[it.key];
      if (node && !node.classList.contains('removing')) {
        if (!hasPending(it.key)) {
          node.querySelector('.an-ci-q').textContent = it.quantity;
          node.querySelector('.an-ci-price').textContent = money(it.final_line_price);
          node.setAttribute('data-unit', it.quantity > 0 ? Math.round(it.final_line_price / it.quantity) : 0);
        }
      } else {
        node = makeLine(it);
        if (prev) {
          if (prev.nextSibling) itemsEl.insertBefore(node, prev.nextSibling);
          else itemsEl.appendChild(node);
        } else {
          itemsEl.insertBefore(node, itemsEl.firstChild);
        }
        enterLine(node);
      }
      prev = node;
    });

    Object.keys(byKey).forEach(function (k) {
      if (!seen[k] && !hasPending(k)) collapseLine(byKey[k]);
    });

    syncEmptyState();
    // The give-back and tee-bundle lookups each fetch from the server; only
    // do that once the shopper has actually opened the bag, never on page load.
    if (everOpened) { refreshGive(); renderBundle(cart); }
    if (cart.item_count > 0) renderCross(cart);
    renderPin(cart);
  }

  // ---- in-bag Pin Pack offer (replaces the pre-checkout detour page) -------
  var pinEl = root.querySelector('[data-cart-pin]');
  function renderPin(cart) {
    if (!pinEl) return;
    var show = window.ANCartCross && window.ANCartCross.shouldOfferPin(cart.items || [], pinEl.getAttribute('data-variant-id'));
    if (show) pinEl.removeAttribute('hidden'); else pinEl.setAttribute('hidden', '');
  }

  function fetchCart(open) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyCart(cart); if (open) setOpen(true); return cart; });
  }

  // ---- add to cart (PDP form, quick-add, cross-sell) ---------------------
  var addInflight = false;
  function add(variantId, qty) {
    if (addInflight || !variantId) return;
    addInflight = true;
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { return r.json(); })
      .then(function () { return fetchCart(true); })
      .finally(function () { addInflight = false; });
  }

  // ---- events -------------------------------------------------------------
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cart-open], .cart-dot');
    if (opener) { e.preventDefault(); fetchCart(true); return; }
    var closer = e.target.closest('[data-cart-close]');
    if (closer) { e.preventDefault(); setOpen(false); return; }
    // Click anywhere outside the cart panel while the drawer is open closes it
    // (the dimmed backdrop / overlay). Openers are handled above and have returned.
    if (root.classList.contains('open') && !e.target.closest('.an-cart-panel')) {
      setOpen(false); return;
    }
    // quantity steppers: instant UI, debounced send
    var step = e.target.closest('.an-ci-step');
    if (step) {
      var line = step.closest('.an-ci');
      var qEl = line.querySelector('.an-ci-q');
      var q = Math.max(0, (parseInt(qEl.textContent, 10) || 0) + parseInt(step.getAttribute('data-step'), 10));
      qEl.textContent = q;
      line.querySelector('.an-ci-price').textContent = money((parseInt(line.getAttribute('data-unit'), 10) || 0) * q);
      if (q === 0) collapseLine(line);
      optimisticTotals();
      queueChange(line.getAttribute('data-key'), q);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      var l = rm.closest('.an-ci');
      collapseLine(l);
      l.querySelector('.an-ci-q').textContent = 0;
      optimisticTotals();
      queueChange(l.getAttribute('data-key'), 0);
      return;
    }
    // quick-add from PLP
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      var vid = qa.getAttribute('data-variant-id');
      if (vid) { add(vid, 1); }
      return;
    }
    // toggle size chooser on a card
    var qt = e.target.closest('[data-quick-toggle]');
    if (qt) { e.preventDefault(); qt.closest('.card').classList.toggle('qa-open'); return; }
  });

  // intercept product add-to-cart forms -> AJAX + open drawer
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    if (addInflight) return;
    addInflight = true;
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          // Shopify refused the add (sold-out race, bad gift-card recipient email or
          // send date). Its own message names the field; silently opening an
          // unchanged bag here is what hid failures before 2026-08-14.
          // `message` is always a plain sentence; `description` can be an object keyed
          // by field, so it only backstops when it is actually a string.
          var msg = res.body && (res.body.message || (typeof res.body.description === 'string' && res.body.description));
          window.alert(msg || 'That didn\'t make it into your bag. Give it another try.');
          return;
        }
        return fetchCart(true);
      })
      .finally(function () { addInflight = false; });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('open')) setOpen(false);
  });

  // The pre-checkout pin detour page was retired 2026-10-01 (checkout review item 3): the Pin Pack
  // offer now shows inside the bag (renderPin), so Checkout always goes straight to checkout.

  // keep badge fresh on load
  fetchCart(false);
  window.anCartRefresh = function () { return fetchCart(false); };
  window.anCartAdd = add;
})();
